import { Translate } from 'react-redux-i18n'
import { fontSizes } from '../../../../../../configs/fontSize'
import { Element } from '../../../../../common/html/element'
import { Image } from '../../../../../common/image'
import { COMPONENTS } from '../../../../../routers/constants'
import classes from '../../../../index.module.scss'
import BenefitCheckSvg from '../../icon/benefitCheck.svg'

const HEIGHT_BENEFIT = 390

export const Benefit = ({ data, isCustom, fontSizeType }) => {
  const heightBenefitRatio =
    fontSizeType === fontSizes.Large.name
      ? fontSizes[fontSizeType].ratio + 0.1
      : fontSizes[fontSizeType].ratio

  return (
    <>
      <div
        className={classes.benefit}
        style={{ height: HEIGHT_BENEFIT * heightBenefitRatio }}
      >
        <div className={['fw600', classes.benefitTitle].join(' ')}>
          <Translate value="userManagement.upgradeViewPlan.BENEFITS" />
        </div>
        {data.map((item) => (
          <div
            className={['flexRow alignItemsCenter', classes.benefitRow].join(
              ' ',
            )}
            key={item.id}
          >
            <Image src={BenefitCheckSvg} className={classes.benefitCheckImg} />
            <div className={classes.benefitItem}>
              {isCustom ? <Translate value={item.benefit} /> : item.benefit}
            </div>
          </div>
        ))}
      </div>
      {isCustom ? (
        <span style={{ marginBottom: 20, marginRight: 12 }}>&nbsp;</span>
      ) : (
        <div
          className="dFlex justifyContentEnd cursorPointer"
          style={{ color: '#2C73E8', marginBottom: 20, marginRight: 12 }}
        >
          <Element
            elementName="a"
            style={{ color: '#2C73E8' }}
            href={
              COMPONENTS.userManagement.components.subscriptionPayment
                .components.viewDetailPlan.route
            }
            target="_blank"
            className="cursorPointer"
          >
            <Translate value="userManagement.upgradeViewPlan.LEARN_MORE" />
          </Element>
        </div>
      )}
    </>
  )
}
